'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _colors = require('../../../constants/colors');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PolicyPaymentIcon = function (_React$Component) {
    _inherits(PolicyPaymentIcon, _React$Component);

    function PolicyPaymentIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PolicyPaymentIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PolicyPaymentIcon.__proto__ || Object.getPrototypeOf(PolicyPaymentIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (width, height, primary) {
            return _react2.default.createElement(
                'svg',
                { id: 'Insurance_Policies_Payment', 'data-name': 'Insurance Policies Payment', xmlns: 'http://www.w3.org/2000/svg', width: '100', height: '99.99', viewBox: '0 0 100 99.99' },
                _react2.default.createElement(
                    'g',
                    { id: 'Group_2613', 'data-name': 'Group 2613' },
                    _react2.default.createElement('path', { id: 'Path_12449', 'data-name': 'Path 12449', d: 'M79.12,0H7.93A7.942,7.942,0,0,0,0,7.93V59.7a7.949,7.949,0,0,0,7.93,7.93H39.22a1.46,1.46,0,1,0,0-2.92H7.93a5.03,5.03,0,0,1-5.02-5.02V22.33H84.13V33.82a1.46,1.46,0,0,0,2.92,0V7.93A7.942,7.942,0,0,0,79.12,0ZM2.91,19.42V7.93A5.023,5.023,0,0,1,7.93,2.91H79.12a5.036,5.036,0,0,1,5.02,5.02V19.42Z', fill: _colors.Colors.Primary }),
                    _react2.default.createElement('path', { id: 'Path_12450', 'data-name': 'Path 12450', d: 'M40.29,35.6H14.4a1.46,1.46,0,1,0,0,2.92H40.29a1.46,1.46,0,1,0,0-2.92Z', fill: _colors.Colors.Primary }),
                    _react2.default.createElement('path', { id: 'Path_12451', 'data-name': 'Path 12451', d: 'M14.4,48.54a1.46,1.46,0,1,0,0,2.92H27.34a1.46,1.46,0,0,0,0-2.92Z', fill: _colors.Colors.Primary })
                ),
                _react2.default.createElement(
                    'g',
                    { id: 'Group_2614', 'data-name': 'Group 2614' },
                    _react2.default.createElement('path', { id: 'Path_12452', 'data-name': 'Path 12452', d: 'M95.62,49.56a49.614,49.614,0,0,0-40.16-.01,7.2,7.2,0,0,0-4.4,6.64V69.76A30.7,30.7,0,0,0,75.21,99.95a1.648,1.648,0,0,0,.32.04,1.17,1.17,0,0,0,.32-.04A30.694,30.694,0,0,0,100,69.77V56.2A7.206,7.206,0,0,0,95.62,49.56Zm1.46,20.21h0A27.79,27.79,0,0,1,75.53,97.04,27.78,27.78,0,0,1,53.98,69.77V56.19a4.313,4.313,0,0,1,2.64-3.97,46.716,46.716,0,0,1,37.85.01,4.3,4.3,0,0,1,2.62,3.96Z', fill: _colors.Colors.Secondary }),
                    _react2.default.createElement('path', { id: 'Path_12453', 'data-name': 'Path 12453', d: 'M75.31,70.54c-2.73,0-5.03-1.56-5.03-3.41s2.3-3.41,5.09-3.41A5.531,5.531,0,0,1,80,65.9a1.456,1.456,0,0,0,2.32-1.76,8.422,8.422,0,0,0-5.55-3.24V59.03a1.46,1.46,0,0,0-2.92,0v1.9c-3.69.55-6.49,3.12-6.49,6.21,0,3.49,3.56,6.32,7.94,6.32,2.72,0,5.02,1.56,5.02,3.41s-2.3,3.41-5.09,3.41A5.557,5.557,0,0,1,70.6,78.1a1.456,1.456,0,1,0-2.32,1.76,8.457,8.457,0,0,0,5.56,3.25v1.86a1.46,1.46,0,0,0,2.92,0v-1.9c3.68-.55,6.48-3.12,6.48-6.21C83.24,73.38,79.68,70.54,75.31,70.54Z', fill: _colors.Colors.Secondary })
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PolicyPaymentIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || _sizes.Sizes.md;
            size = (0, _getSize2.default)(size);
            return _react2.default.createElement(
                _layout2.default,
                { size: 100 },
                this.getIcon(null, null, this.props.primary)
            );
        }
    }]);

    return PolicyPaymentIcon;
}(_react2.default.Component);

exports.default = PolicyPaymentIcon;